<template>
    <div>
      <v-tabs
          v-if="!is_searched"
          v-model="tab"
          background-color="#eef2f4"
          centered
          class="elevation-0 d-grid"
          @change="$emit('change_tab',tab)"
          color="#ff8080"
          fixed-tabs
          icons-and-text
      >
        <v-tab href="#tab-1">
          <div v-if="tab==='tab-1'">لیست کارها</div>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#DFDFDF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4133 10.6667H29.588C33.7067 10.6667 36 13.0401 36 17.1067V30.8801C36 35.0134 33.7067 37.3334 29.588 37.3334H18.4133C14.36 37.3334 12 35.0134 12 30.8801V17.1067C12 13.0401 14.36 10.6667 18.4133 10.6667ZM18.7733 16.8801V16.8667H22.7587C23.3333 16.8667 23.8 17.3334 23.8 17.9054C23.8 18.4934 23.3333 18.9601 22.7587 18.9601H18.7733C18.1987 18.9601 17.7333 18.4934 17.7333 17.9201C17.7333 17.3467 18.1987 16.8801 18.7733 16.8801ZM18.7733 24.9867H29.2267C29.8 24.9867 30.2667 24.5201 30.2667 23.9467C30.2667 23.3734 29.8 22.9054 29.2267 22.9054H18.7733C18.1987 22.9054 17.7333 23.3734 17.7333 23.9467C17.7333 24.5201 18.1987 24.9867 18.7733 24.9867ZM18.7733 31.0801H29.2267C29.7587 31.0268 30.16 30.5721 30.16 30.0401C30.16 29.4934 29.7587 29.0401 29.2267 28.9867H18.7733C18.3733 28.9467 17.9867 29.1334 17.7733 29.4801C17.56 29.8134 17.56 30.2534 17.7733 30.6001C17.9867 30.9334 18.3733 31.1334 18.7733 31.0801Z" :fill="tab==='tab-1'?'#D20003':'black'"/>
          </svg>

        </v-tab>
        <v-tab href="#tab-2">
          <div v-if="tab==='tab-2'">درحال انجام</div>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#DFDFDF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.227 10.6665H29.787C34.307 10.6665 37.3337 13.8398 37.3337 18.5598V29.4532C37.3337 34.1598 34.307 37.3332 29.787 37.3332H18.227C13.707 37.3332 10.667 34.1598 10.667 29.4532V18.5598C10.667 13.8398 13.707 10.6665 18.227 10.6665ZM18.027 25.5998C17.147 25.5998 16.427 24.8798 16.427 23.9998C16.427 23.1198 17.147 22.4012 18.027 22.4012C18.907 22.4012 19.627 23.1198 19.627 23.9998C19.627 24.8798 18.907 25.5998 18.027 25.5998ZM22.4003 23.9998C22.4003 24.8798 23.1203 25.5998 24.0003 25.5998C24.8803 25.5998 25.6003 24.8798 25.6003 23.9998C25.6003 23.1198 24.8803 22.4012 24.0003 22.4012C23.1203 22.4012 22.4003 23.1198 22.4003 23.9998ZM28.3737 23.9998C28.3737 24.8798 29.0937 25.5998 29.9737 25.5998C30.8537 25.5998 31.5603 24.8798 31.5603 23.9998C31.5603 23.1198 30.8537 22.4012 29.9737 22.4012C29.0937 22.4012 28.3737 23.1198 28.3737 23.9998Z" :fill="tab==='tab-2'?'#D20003':'black'"/>
          </svg>
        </v-tab>
        <v-tab href="#tab-3">
          <div v-if="tab==='tab-3'">در صف خرید</div>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#DFDFDF" />
            <path d="M27.5126 16.2095H27.5123C27.5123 14.2345 25.9053 12.6277 23.9305 12.6277C21.9555 12.6277 20.3486 14.2345 20.3486 16.2095V17.4544H27.5126V16.2095Z" fill="black"/>
            <path d="M30.0355 19.1145H29.1726V20.2783C29.4391 20.5107 29.6113 20.8491 29.6113 21.2308C29.6113 21.9316 29.0433 22.4998 28.3426 22.4998C27.6425 22.4998 27.074 21.9316 27.074 21.2308C27.074 20.8493 27.2458 20.511 27.5127 20.2786V19.1145H20.3488V20.2783C20.6154 20.511 20.7875 20.8491 20.7875 21.2308C20.7875 21.9316 20.2193 22.4998 19.5188 22.4998C18.818 22.4998 18.2501 21.9316 18.2501 21.2308C18.2501 20.8493 18.4221 20.5107 18.6888 20.2783V19.1145H17.8259C17.3381 19.1145 16.9414 19.5112 16.9414 19.999V31.8567C16.9414 32.3445 17.3381 32.7412 17.8259 32.7412H30.0354C30.5229 32.7412 30.9199 32.3441 30.9199 31.8567V19.999C30.92 19.5112 30.523 19.1145 30.0355 19.1145Z" fill="black"/>
            <path d="M23.9997 8C15.1634 8 8 15.1638 8 23.9997C8 32.8356 15.1634 40 23.9997 40C32.8361 40 40 32.836 40 23.9997C40 15.1635 32.8361 8 23.9997 8ZM32.5799 31.8566C32.5799 33.2594 31.4381 34.4009 30.0354 34.4009H17.826C16.4231 34.4009 15.2816 33.2595 15.2816 31.8566V19.9988C15.2816 18.596 16.423 17.4545 17.826 17.4545H18.6889V16.2096C18.6889 13.3192 21.0405 10.9678 23.9307 10.9678C26.821 10.9678 29.1725 13.3194 29.1725 16.2096V17.4545H30.0354C31.4381 17.4545 32.5799 18.5959 32.5799 19.9988V31.8566Z" fill="black"/>
          </svg>
        </v-tab>
        <v-tab href="#tab-4">
          <div v-if="tab==='tab-4'">انتظار تایید</div>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#DFDFDF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.227 10.6665H29.787C34.307 10.6665 37.3337 13.8398 37.3337 18.5598V29.4532C37.3337 34.1598 34.307 37.3332 29.787 37.3332H18.227C13.707 37.3332 10.667 34.1598 10.667 29.4532V18.5598C10.667 13.8398 13.707 10.6665 18.227 10.6665ZM18.027 25.5998C17.147 25.5998 16.427 24.8798 16.427 23.9998C16.427 23.1198 17.147 22.4012 18.027 22.4012C18.907 22.4012 19.627 23.1198 19.627 23.9998C19.627 24.8798 18.907 25.5998 18.027 25.5998ZM22.4003 23.9998C22.4003 24.8798 23.1203 25.5998 24.0003 25.5998C24.8803 25.5998 25.6003 24.8798 25.6003 23.9998C25.6003 23.1198 24.8803 22.4012 24.0003 22.4012C23.1203 22.4012 22.4003 23.1198 22.4003 23.9998ZM28.3737 23.9998C28.3737 24.8798 29.0937 25.5998 29.9737 25.5998C30.8537 25.5998 31.5603 24.8798 31.5603 23.9998C31.5603 23.1198 30.8537 22.4012 29.9737 22.4012C29.0937 22.4012 28.3737 23.1198 28.3737 23.9998Z" :fill="tab==='tab-4'?'#D20003':'black'"/>
          </svg>
        </v-tab>
        <v-tab href="#tab-5">
          <div v-if="tab==='tab-5'">انجام شده</div>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#DFDFDF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.227 10.6665H29.787C34.307 10.6665 37.3337 13.8398 37.3337 18.5598V29.4545C37.3337 34.1598 34.307 37.3332 29.787 37.3332H18.227C13.707 37.3332 10.667 34.1598 10.667 29.4545V18.5598C10.667 13.8398 13.707 10.6665 18.227 10.6665ZM23.2403 27.9865L29.5737 21.6532C30.027 21.1998 30.027 20.4665 29.5737 19.9998C29.1203 19.5465 28.3737 19.5465 27.9203 19.9998L22.4137 25.5065L20.0803 23.1732C19.627 22.7198 18.8803 22.7198 18.427 23.1732C17.9737 23.6265 17.9737 24.3598 18.427 24.8265L21.6003 27.9865C21.827 28.2132 22.1203 28.3198 22.4137 28.3198C22.7203 28.3198 23.0137 28.2132 23.2403 27.9865Z" :fill="tab==='tab-5'?'#D20003':'black'"/>
          </svg>

        </v-tab>
      </v-tabs>
      <v-data-table
          hide-default-footer
          :headers="headers"
          item-value="name"
          :items-per-page="20"
          :loading="receiving_tasks"
          :items="tasks.results"
          mobile-breakpoint="0"
          loading-text="درحال دریافت اطلاعات ..."
          no-data-text="کاری موجود نیست!"
      >
        <template v-slot:item="{ item, index }">
          <tr
              v-if="index === 0"
          >
            <td
                colspan="8"
                class="text-center"
                style="padding: 0;background-color: #4caf50;height: 2em;color: white;"
            >
              <strong>
                {{ new Date(item.created_at.split('T')[0]).toLocaleDateString('fa-IR') }}
              </strong>
            </td>
          </tr>
          <tr
              :class="{'unread-row': (item.unread_messages_count || 0) > 0}"
              @mouseover="hoveredRow = index"
              @mouseleave="hoveredRow = null"
          >
            <td class="text-center">#{{ item.id }}</td>
            <td>{{ item.title }}</td>
            <td>
              <v-tooltip v-if="item.description.length > 40" top color="gray" max-width="50em">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    {{ item.description.slice(0, 40) + '...' }}
                  </div>
                </template>
                <span>{{ item.description }}</span>
              </v-tooltip>
              <div v-else>
                {{ item.description }}
              </div>
            </td>
            <td class="text-center">
              <v-badge v-if="item.unread_messages_count" :content="item.unread_messages_count" color="red" overlap>
                <v-icon color="red">mdi-bell-alert</v-icon>
              </v-badge>
              <v-icon v-else color="grey lighten-1">mdi-bell-outline</v-icon>
            </td>
            <td class="text-center">
              <v-chip outlined>{{ item.location }}</v-chip>
            </td>
            <td class="text-center">
              <v-tooltip top color="red">
                <template v-slot:activator="{ on, attrs }">
                  <a v-bind="attrs" v-on="on">
                    {{ new Date(item.created_at.split('T')[0]).toLocaleDateString('fa-IR') }}
                  </a>
                </template>
                <span>{{ convert_en_to_fa_number(item.created_at.split('T')[1].split('.')[0]) }}</span>
              </v-tooltip>
            </td>
            <td class="text-center">
              <v-avatar class="rounded-circle my-5">
                <v-img
                    v-if="item.created_user['profile_picture']"
                    :src="item.created_user['profile_picture']"
                    alt="profile_pic"
                    width="50px"
                    height="50px"
                ></v-img>
              </v-avatar>
              <template v-if="!item.created_user.first_name && !item.created_user.last_name">
                {{ item.created_user.username }}
              </template>
              {{ `${item.created_user.first_name} ${item.created_user.last_name}` }}
            </td>
            <td>
              <div v-if="hoveredRow === index">
                <v-btn class="m-3 mx-5" color="red" text link @click="task_d.task=item;confirmViewEn=true">تاییدیه</v-btn>
                <v-btn class="m-3 mx-5" color="primary" outlined link @click="handler_click_row(item)">جزئیات</v-btn>
              </div>
              <div v-else>
                <div v-for="user in item.worker_users.slice(0,3)" :key="user.id">
                  <v-avatar class="rounded-circle mt-1">
                    <v-img
                        v-if="user['profile_picture']"
                        :src="user['profile_picture']"
                        alt="profile_pic"
                        width="50px"
                        height="50px"
                    ></v-img>
                  </v-avatar>
                  {{ user.get_full_name }}
                </div>
                <div v-if="item.worker_users.length > 3" class="mx-auto text-center">
                  ...
                </div>
                <div v-else-if="item.worker_users.length === 0" class="text-center">
                  <v-chip class="mx-auto">تعریف نشده</v-chip>
                </div>
              </div>
            </td>
          </tr>
          <tr
              v-if="tasks.results.length !== index &&
                    item.created_at.split('T')[0] !== tasks.results[tasks.results.length > index + 1 ? index + 1 : index]['created_at'].split('T')[0]
                   "
          >
            <td
                colspan="8"
                class="text-center"
                style="padding: 0;background-color: #4caf50;height: 2em;color: white;"
            >
              <strong>
                {{ new Date(tasks.results[index + 1].created_at.split('T')[0]).toLocaleDateString('fa-IR') }}
              </strong>
            </td>
          </tr>
        </template>
      </v-data-table>

        <template v-if="tasks.results && tasks.count > 20" >
              <div class="text-center mt-3">
                <v-pagination v-model="page" color="#D20003" rounded @input="$emit('change_page', page)"
                              :length="tasks.count % 20 !== 0 ? parseInt(tasks.count / 20) + 1 : parseInt(tasks.count / 20)"
                              :total-visible="7"></v-pagination>
              </div>
        </template>
        <taskDetail :task="task_d.task" :show_detail="task_d.show_detail"
                    @close="close_detail_view()"
        />
      <confirmTask :task="task_d.task" :show="confirmViewEn" @close="close_confirm_view()"/>
    </div>
</template>

<script>
import taskDetail from "@/components/admin/tasks/task-detail.vue";
import confirmTask from "@/components/admin/confirm_task/confirm.vue";

export default {
  name: "TasksList",
    props: ['tasks', 'receiving_tasks', 'page', 'is_searched'],
    components: { taskDetail , confirmTask },
    data: () => ({
        task_d: {},
        tab: 1,
        hoveredRow: null,
        confirmViewEn: false,
        headers: [
            {key: 'num', text: 'کد',sortable: false, align: 'center', value: 'id' },
            {key: 'name', text: 'نام',sortable: false, align: 'right', value: 'title' },
            {key: 'des', text: 'شرح', sortable: false, align: 'right', value: 'description' },
            {key: 'messages', text: 'پیام', sortable: false, align: 'center', value: 'unread_messages_count' },
            {key: 'location', text: 'مکان',sortable: false, align: 'center', value: 'location' },
            {key: 'created_at', text: 'زمان ثبت',sortable: false, align: 'center', value: 'created_at' },
            {key: 'created_user', text: 'ساخته شده توسط',sortable: false, align: 'center', value: "created_user" },
            {key: 'user_1', text: 'کاربر سطح۱',sortable: false, align: 'center', value: "users" },

        ]
    }),
    methods: {
        close_detail_view(){
          this.task_d.show_detail=false;
          this.$emit('refresh_tasks');
        },
        close_confirm_view(){
          this.confirmViewEn = false;
          this.$emit('refresh_tasks');
        },
        handler_click_row(task) {
            this.task_d = { task: task, show_detail: true }
        },
    }
}
</script>

<style scoped>
.unread-row {
  background-color: #fff5f5;
}
</style>
